import { render, staticRenderFns } from "./RateBasisPer.vue?vue&type=template&id=a88ca884&"
import script from "./RateBasisPer.vue?vue&type=script&lang=js&"
export * from "./RateBasisPer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a88ca884')) {
      api.createRecord('a88ca884', component.options)
    } else {
      api.reload('a88ca884', component.options)
    }
    module.hot.accept("./RateBasisPer.vue?vue&type=template&id=a88ca884&", function () {
      api.rerender('a88ca884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/RateBasisPer.vue"
export default component.exports